<template>
  <BaseChart
    height="250px"
    chart-height="150px"
    title="Price development in local currency"
    :chart-data="mergedChartData"
    :subtitle="subtitle"
  >
    <template #widget-options>
      <slot name="widget-options"></slot>
    </template>
  </BaseChart>
</template>

<script>
import { commonPropertiesMixin } from './common-properties-mixin'
import { customChartData } from '@/reusable/base-chart/common-custom-chart-data'

export default {
  mixins: [commonPropertiesMixin('price-development-in-local-currency', customChartData)],

  computed: {
    subtitle() {
      if (!this.supportData) return 'Local currency'
      return `Local currency (${this.supportData.merge_data['[[ CURRENCY ]]']})`
    }
  }
}
</script>
